export default [
    {
        path: 'implementers',
        name: 'projects-implementers',
        meta: {
            modules: ['crm'],
            authentication_required: true,
            authorization_required: null,
            translate: (t) => {
                return t('menu_points.implementers').ucFirst();
            },
        },
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        redirect: { name: 'projects-implementers-list' },
        children: [
            {
                path: '',
                name: 'projects-implementers-list',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t) => {
                        return t('menu_points.implementers').ucFirst();
                    },
                },
                component: () => import('@/views/pages/crm/implementers/list.vue'),
            },
            {
                path: 'create',
                name: 'projects-implementer-create',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t, tc) => t('base.create_new_item', {item: tc('projects::implementers.implementer', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/crm/implementers/item.vue'),
            },
            {
                path: ':id(\\d+)',
                name: 'projects-implementer-edit',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t, tc) => t('base.edit_item', {item: tc('projects::implementers.implementer', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/crm/implementers/item.vue'),
            },
        ]
    },

];